import { dictionary } from 'commons/types/dictionaries'

export const isIssuingStateRequiredCountry = (country: string | undefined) => {
  if (country && ['US', 'AS', 'GU', 'MH', 'FM', 'CA', 'MP', 'PW', 'PR', 'VI', 'MX'].indexOf(country) !== -1) {
    return true
  }
  return false
}

export const determineIssuingStateData = (country: string | undefined) => {
  switch (country) {
    case 'US':
      return dictionary.usStates
    case 'AS':
      return dictionary.asStates
    case 'GU':
      return dictionary.guStates
    case 'MH':
      return dictionary.mhStates
    case 'FM':
      return dictionary.fmStates
    case 'CA':
      return dictionary.caStates
    case 'MP':
      return dictionary.mpStates
    case 'PW':
      return dictionary.pwStates
    case 'PR':
      return dictionary.prStates
    case 'VI':
      return dictionary.viStates
    case 'MX':
      return dictionary.mxStates
  }
  return []
}
